import React, { Component } from 'react';

/* import './styles.css' */

import Button from '../common/button';
// import CheckBox from '../common/checkBox'
import AutoComplete from '../common/autoComplete';
// import FloatingInput from '../common/textField';
import { opdbGTM } from '../../utils/pulseUtils';
import Pagination from '../Pagination';



const renderElements = function (item, value) {
  return (
    <div className='cursor'>
      <p className='cityStyle'>
        {
          /* value ? hightLightText(item, value)
            : item */
          item
        }
      </p>
    </div>
  );
};
/* function hightLightText(str, val) {
  var index = str.toLowerCase().indexOf(val.toLowerCase());
  if (index > 0) {
    return [
      str.substring(0, index),
      <b key={1} style={{ color: '#000' }}>{val}</b>,
      str.substring(index + val.length),
    ];
  } else if (index === 0) {
    return [
      <b key={1} style={{ color: '#000' }}>{str.substring(0, index + val.length)}</b>,
      str.substring(index + val.length)
    ];
  }
  return str;
} */
class RatingsTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      source: { name: '' },
      destination: { name: '' },
      busType: '',
      pageNum: 1,
      filteredSourceCityList: [],
      filteredDestCityList: [],
      filteredBusTypeList: [],
      sortBy: {
        change: {},
        rating: {},
        departure: {}
      },
      currentPage: 1
    }
  }
  onSourceItemSelect = (item) => {
    let sourceCity = this.props.sourceCitiesV2.find(city => city.display_name === item);
    this.setState({
      source: {
        name: item,
        city_id: sourceCity && sourceCity.city_id
      }
    });
  }
  
  onDestinationItemSelect = (item) => {
    let destinationCity = this.props.destCitiesV2.find(city => city.display_name === item);
    this.setState({
      destination: {
        name: item,
        city_id: destinationCity && destinationCity.city_id
      }
    });
  }

  clearSourceItemSelection = () => {
    this.setState({ source: { name: '' } });
  }

  clearDestinationItemSelection = () => {
    this.setState({ destination: { name: '' } });
  }
  
  // onServiceItemSelect = (item) => {
  //   this.setState({ busType: { name: item } })
  // }
  onSearchClick = () => {
    const { source, destination, busType } = this.state;
    let query = {
      pageNo: 1,
      source: source.city_id,
      destination: destination.city_id,
      service: busType
    }
    // this.props.filterRatingsList(query);
    this.props.ratingInformationList(query)
    if (!source && !destination && !busType) {
      alert('Kindly enter source or destination or  service for filtering');
      return;
    }
    opdbGTM.ratingsSearchClicked(source, destination);
  }
  changeSortParams(sortBy, type) {
    let sortType = '';
    if (this.props.sorting.sortBy === sortBy) {
      sortType = this.props.sorting.sortType === 'dsc' ? 'asc' : 'dsc';
    }
    else {
      sortType = 'asc';
    }
    this.props.sortDataBy({ sortBy, sortType });
  }
  showRouteRatingsDetails(event) {
    let paytm_trip_id, route_time_id, color_code,average_rating, index, service, query;
    if (event.target.parentElement.classList.contains('ratings-table-row')) {
      index = parseInt(event.target.parentElement.getAttribute('index'));
      service = this.props.filteredServicesCollection[index];
      if(!service.hasRatings){
        alert ("Route does not contain ratings");
        return;
      }
      if (service.rnr) {
        let { paytm_source_name, paytm_dest_name, bus_type, first_boarding_time } = service;
        paytm_trip_id = service.rnr.paytm_trip_id;
        route_time_id = service.rnr.route_time_id;
        first_boarding_time = first_boarding_time && first_boarding_time.length === 4 ? `${first_boarding_time.slice(0, 2)}:${first_boarding_time.slice(2)}` : '';
        if (service.rnr.rating_details) {
          average_rating = service.rnr.rating_details.average_rating || '';
          color_code = service.rnr.rating_details.color_code || ''; 
        }
        query = { params: { paytm_trip_id, route_time_id }, paytm_source_name, paytm_dest_name, bus_type, first_boarding_time, average_rating, color_code};
        this.props.getRouteRatingsDetails(query);
      }
    }
  }

  getDisplayNames(cityArray) {
    if (!Array.isArray(cityArray)) {
      return [];
    }
    return cityArray.map(city => city && city.display_name ? city.display_name : null);
  }
  componentDidUpdate(prevProps) {
    if(this.props.sourceCitiesV2 !== prevProps.sourceCitiesV2) {
      const filteredSourceCityList = this.getDisplayNames(this.props.sourceCitiesV2);
      this.setState({ filteredSourceCityList});
    }
    if(this.props.destCitiesV2 !== prevProps.destCitiesV2) {
      const filteredDestCityList = this.getDisplayNames(this.props.destCitiesV2);
      this.setState({ filteredDestCityList});
    }
  }

  fetchCities = (value, fieldType) => {
    this.props.getV2Cities(value, fieldType);
  }

  updateBusType = (value) => {
    this.setState({ busType: value });
  }

  handlePageChange = (page) => {
    const { source, destination, busType } = this.state;
    let query = {
      pageNo: page,
      source: source.city_id,
      destination: destination.city_id,
      service: busType
    }
    this.setState({ currentPage: page });
    this.props.ratingInformationList(query);
  }

  render(){
    const { filteredServicesCollection, sorting, ratingInformationList, totalServiceCount, sourceCitiesV2, destCitiesV2 } = this.props;
    const { source, destination, busType, filteredSourceCityList, filteredDestCityList, filteredBusTypeList, currentPage } = this.state;
    const { sortBy, sortType } = sorting;
  
    return (
      <div className="col-xs-12 payout-content">
        <div className="row search-row">
          <div className="search-header col-xs-12">Search by Service:</div>
          <div className="col-xs-3 deal-padding-right deal-textfield">
            <AutoComplete
              name="source"
              openOnFocus={true}
              placeholder="Source"
              ref={(source) => { this.source = source; }}
              onSelect={this.onSourceItemSelect}
              onClear={this.clearSourceItemSelection}
              defaultValue={source || ''}
              fieldName='source'
              onChange={this.fetchCities}
              renderElements={renderElements}
              listData={filteredSourceCityList}
            />
          </div>
          <div className="col-xs-3 deal-textfield deal-padding-right">
            <AutoComplete
              name="destination"
              openOnFocus={true}
              placeholder="Destination"
              ref={(destination) => { this.destination = destination; }}
              onSelect={this.onDestinationItemSelect}
              onClear={this.clearDestinationItemSelection}
              defaultValue={destination || ''}
              fieldName='destination'
              onChange={this.fetchCities}
              renderElements={renderElements}
              listData={filteredDestCityList}
            />
          </div>
          <div className="col-xs-3 deal-textfield deal-padding-right">
            {/* <AutoComplete
              name="service"
              openOnFocus={true}
              placeholder="Select Service"
              ref={(busType) => { this.busType = busType; }}
              onSelect={this.onServiceItemSelect}
              citiesHeading="Suggested Services"
              defaultValue={busType || ''}
              fieldName='service'
              onChange={this.fetchCities}
              renderElements={renderElements}
              listData={[]}
            /> */}
            {/* <FloatingInput
              name="service"
              placeholder="Select Service"
              onChange={this.updateBusType}
              value={busType || ''}
            /> */}
          </div>
          <div className="col-xs-2" style={{ textAlign: 'end' /*marginLeft: 30*/ }}><Button label="Search" onButtonClick={this.onSearchClick} /></div>
        </div>

        <Pagination
          totalPages={Math.ceil(totalServiceCount / 10)}
          currentPage={currentPage}
          onPageChange={(page) => this.handlePageChange(page)}
        />

        <div className="ratings-content">
          <table className="app-table" >
            <thead>
              <tr className="ratings-table-header">
                <th>Route</th>
                <th>Bus Type </th>
                <th onClick={() => this.changeSortParams('departure')}><span className={`ratings-sort-header ${sortType === 'asc' ? 'asc' : 'dsc'}-arrow ${sortBy === 'departure' ? 'active' : ''}`}>Departure</span></th>
                <th onClick={() => this.changeSortParams('rating')}><span className={`ratings-sort-header ${sortType === 'asc' ? 'asc' : 'dsc'}-arrow ${sortBy === 'rating' ? 'active' : ''}`}>Current Rating</span></th>
                <th onClick={() => this.changeSortParams('change')}><span className={`ratings-sort-header ${sortType === 'asc' ? 'asc' : 'dsc'}-arrow ${sortBy === 'change' ? 'active' : ''}`}>Change</span></th>
                <th>Bus</th>

              </tr>
            </thead>
            <tbody onClick={(event) => this.showRouteRatingsDetails(event)}>
              {
                !filteredServicesCollection.length && <tr><td colSpan={9} className="table-no-data">No Data Found</td></tr>
              }
              {
                filteredServicesCollection.map((el, i) => {
                  let changeColor, styles, fifteenDaysChange = '', averageRating = '', boardingTime;
                  boardingTime = el.first_boarding_time && el.first_boarding_time.length === 4 ? `${el.first_boarding_time.slice(0, 2)}:${el.first_boarding_time.slice(2)}` : ''
                  if (el.rnr && el.rnr.rating_details) {
                    changeColor = el.rnr.rating_details.color_code;
                    styles = { color: changeColor };
                    fifteenDaysChange = el.rnr.rating_details.fifteen_days_change || '';
                    averageRating = el.rnr.rating_details.average_rating || '';
                  }
                  return (
                    <tr key={i} className={`ratings-table-row ${ !el.hasRatings ? 'disabled' : ''}`} index={i}>
                      <td>{`${el.paytm_source_name} - ${el.paytm_dest_name}`}</td>
                      <td>{el.bus_type}</td>
                      <td>{boardingTime}</td>
                      <td>{averageRating}</td>
                      <td style={styles}>{fifteenDaysChange}</td>
                      <td>{el.busTags.join(',') || ''}</td>
                    </tr>
                  )
                })
              }
            </tbody>
          </table>
        </div>
      </div>
    )
  }
  
}

export default RatingsTable;